import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

import { selectAppPersistRefreshInterval } from '@store/useAppStorePersist';

export const facilitiesListKey = () => ['facilitiesList'];
export const facilitiesListFn = () => apiClient.get(`${APP_API_URL}get-facilities-list-v2`);

export const useFacilitiesListQuery = () => {
  const refreshInterval = selectAppPersistRefreshInterval();

  return useQuery({
    queryKey: facilitiesListKey(),
    queryFn: facilitiesListFn,
    refetchInterval: refreshInterval,
    select: ({ data }) => data.facilities,
  });
};
